import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";
import { fontFamilySans } from "@clockwise/web-commons/src/styles/type.styles";
import { headerBody } from "../TailoredDefragSummaryCard.styles";
import { baseBody } from "@components/suggestion-body/SuggestionBody.styles";

// ~-~-~-~-~-~-~--~-~-~-
// More Meetings Section
// ~-~-~-~-~-~-~--~-~-~-
const overflow: CSSProperties = {
  // this is the same transition as material-ui uses — makes it feel consistent
  transition: "max-height 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
  maxHeight: 0,
  overflow: "hidden",
};

// ~-~-~-~-~-~-~--~-~-~-
// Show More Button
// ~-~-~-~-~-~-~--~-~-~-
const overflowBtn: CSSProperties = {
  color: colors.blueCool.standard,
  backgroundColor: baseBody.backgroundColor,
  textAlign: "left",
  WebkitFontSmoothing: "antialiased",
  borderRadius: 0,
  width: `100%`,
  borderBottom: headerBody.borderBottom,
  padding: "6px 12px",
};

const overflowBtnLabel: CSSProperties = {
  fontFamily: fontFamilySans,
  fontSize: 14,
  fontWeight: 600,
  textTransform: "none",
  width: "100%",
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
};

const btnIcon: CSSProperties = {};

const btnIconExpanded = {
  ...btnIcon,
  transform: "rotate(180deg)",
};

export const styles = {
  overflow,
  overflowBtn,
  overflowBtnLabel,
  btnIcon,
  btnIconExpanded,
};
